import {
  faCaretCircleDown,
  faCaretCircleUp,
  faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import isString from 'lodash/isString';
import React from 'react';
import { v4 as uuid } from 'uuid';
import 'react-toastify/dist/ReactToastify.css';

import { Button } from '../button';
import { ClipboardCopy } from '../copy';

import styles from './toastr.module.scss';

export default function ToastMessage({
  closeToast,
  message: m,
  details: d,
}: {
  closeToast?: () => void;
  message: React.ReactNode;
  details?: React.ReactNode;
}) {
  const [showDetails, setShowDetails] = React.useState(false);
  let message = m;
  if (m instanceof Error) message = m.message;
  let details = d;
  if (details instanceof Error) details = details.stack || details.message;
  const canCopy = isString(message) || isString(details);
  let textToCopy = isString(message) ? message : '';
  if (isString(details))
    textToCopy += `${textToCopy ? '\n\n\n' : ''}${details}`;
  return (
    <div className="d-flex flex-column m-0">
      <div className="d-flex">
        <div className="flex-grow-1 d-flex align-items-center">
          <div className={styles.overflow}>{message}</div>
        </div>
        <div className="ms-1 d-flex flex-column align-items-center mt-n2">
          <Button
            id={`toast-close-${uuid()}`}
            className="p-0"
            transparent
            onClick={closeToast}
            tooltip="Close"
          >
            <FontAwesomeIcon color="#393b39" icon={faTimes} />
          </Button>
          {canCopy && <ClipboardCopy text={textToCopy} color="#393b39" />}
          {details && (
            <Button
              className="p-0"
              transparent
              onClick={() => setShowDetails(!showDetails)}
              tooltip="Details"
            >
              <FontAwesomeIcon
                color="#393b39"
                icon={showDetails ? faCaretCircleDown : faCaretCircleUp}
              />
            </Button>
          )}
        </div>
      </div>

      {showDetails && (
        <div className="my-2">
          <hr aria-hidden="true" className="m-0 p-0" />
          <div
            style={{ maxHeight: 250 }}
            className={cx('mt-2', styles.overflow)}
          >
            <small>{details}</small>
          </div>
        </div>
      )}
    </div>
  );
}
